angular
    .module('WizApp')
    .service('NoticeService', [
        '$filter',
        '$rootScope',
        function ($filter, $rootScope) {
            const trans = $filter('trans');

            return {
                error(message) {
                    if (message) {
                        message = trans(message);
                    } else {
                        message = trans('wizbii.core.messages.error.ajaxserver');
                    }

                    $rootScope.$emit('toaster:newToast', {
                        type: 'error',
                        message
                    });
                },

                success(message) {
                    if (message) {
                        message = trans(message);
                    }
                    $rootScope.$emit('toaster:newToast', {
                        type: 'success',
                        message
                    });
                }
            };
        }
    ]);
